import { useSyncExternalStore } from "react";

const QUERY = "(min-width: 768px)"; // Tailwind `md`

const subscribe = (cb: () => void) => {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", cb);
  return () => mq.removeEventListener("change", cb);
};
const getSnapshot = () => window.matchMedia(QUERY).matches;
const getServerSnapshot = () => true;

/**
 * Tailwind `md` kırılımıyla aynı eşik; yeniden boyutlandırmada tepki verir.
 * CSS `hidden md:block` ile gizlenen ama yine de mount edilen ağır çocukları
 * (ör. ChatInput) tek viewport'ta tutmak için.
 */
export const useIsDesktop = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

/** Hook dışı (store / event handler): şu an md+ mi? */
export const isDesktopViewport = (): boolean =>
  typeof window !== "undefined" && window.matchMedia(QUERY).matches;
